import * as cx from 'classnames';
import * as React from 'react';
import { SvgIcon } from '..';
import * as Styles from './StepNumber.scss';

interface IOwnProps {
  step: number;
  accent?: boolean;
  icon?: boolean;
}

const StepNumber: React.SFC<IOwnProps> = ({ step, accent, icon }) => {
  const stepNumberClassNames = cx({
    [Styles.number]: true,
    [Styles.accent]: accent,
    [Styles.withIcon]: icon,
  });

  return (
    <span className={stepNumberClassNames}>
      {icon && <SvgIcon icon="checkMark" />}
      {!icon && step}
    </span>
  );
};

export default StepNumber;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/StepNumber/StepNumber.tsx